import { useEffect, useRef } from 'react';

import STYLES from './StartMenu.module.scss';
import MenuItem from './MenuItem';
import { startMenuIconData } from '../../../../../../images/imageData';

const StartMenu = ({ handleClose, buttonRef }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={STYLES.StartMenu} ref={menuRef}>
      <div className={STYLES.StartMenu__VerticalBar}>
        <span>milloy.dev</span>
      </div>
      <div className={STYLES.StartMenu__MenuItems}>
        <MenuItem
          text={'Github'}
          href="https://github.com/connormilloy"
          icon={startMenuIconData.github}
        />
        <MenuItem
          text={'LinkedIn'}
          href="https://www.linkedin.com/in/connor-milloy-0570a4207"
          icon={startMenuIconData.linkedin}
        />
      </div>
    </div>
  );
};

export default StartMenu;
